import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Box from "@material-ui/core/Box"
import Typography from "@material-ui/core/Typography"
import Video from "../../bits/Video"
const useStyles = makeStyles(theme => ({
  Section: {
    background: theme.palette.secondary.main,
    padding: theme.spacing(35, 3, 25, 3),
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(35, 2, 15, 2),
    },
  },
  GridContainer: {
    display: "grid",
    gridTemplateColumns: "1.1fr 1fr",
    gap: theme.spacing(3),
    margin: "auto",
    maxWidth: 1200,
    maxHeight: "fit-content",
    placeContent: "center / center",
    justifyItems: "space-around",

    [theme.breakpoints.down(700)]: {
      gridTemplateRow: "1fr",
      gridTemplateColumns: "unset",
      gap: theme.spacing(4),
    },

    "& h2": {
      fontSize: theme.typography.fontSize + 23,
      marginBottom: theme.spacing(2),

      [theme.breakpoints.down("md")]: {
        fontSize: theme.typography.fontSize + 17,
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: theme.typography.fontSize + 9,
      },
    },
  },
  GridItem: {
    "&  p:first-of-type": {
      fontWeight: "500",
    },
    textAlign: "justify",
    padding: "auto",
    boxSizing: "border-box",
  },
  videoBox: {
    position: "relative",
    maxWidth: "480px",
    minHeight: "270px",
    width: "100%",
    height: "100%",
    margin: "auto",
    boxSizing: "border-box",

    "&:before": {
      position: "absolute",
      content: `''`,
      top: -theme.spacing(10),
      left: -theme.spacing(5),
      maxWidth: theme.spacing(200),
      maxHeight: theme.spacing(180),
      width: "100%",
      height: "100%",
      backgroundColor: "purple",
      backgroundSize: theme.spacing(2, 2),
      backgroundImage: `linear-gradient(to right, ${theme.palette.secondary.main} 11px, transparent 11px), linear-gradient(to bottom, ${theme.palette.secondary.main} 11px, transparent 11px)`,
      border: "unset",
    },
  },
}))
export default () => {
  const classes = useStyles()
  return (
    <Box component="section" id="about" className={classes.Section}>
      <Box className={classes.GridContainer}>
        <Box className={classes.GridItem}>
          <Box className={classes.videoBox}>
            <Video />
          </Box>
        </Box>
        <Box className={classes.GridItem}>
          <Typography variant="h2">
            FROM EVENTS PLANNING TO FULL SERVICE CATERING AND DELIVERIES
          </Typography>
          <Typography paragraph>
            WE LOVE COLLABORATING WITH PEOPLE INTERESTED IN CREATING MEMORABLE
            EVENTS.
          </Typography>
          <Typography paragraph>
            Gloone Events provide event planning, management, stage decoration,
            and catering services for a plethora of events ranging from wedding
            events, birthday parties, corporate seminars, anniversaries, holiday
            parties, corporate functions to fashion concerts held within
            Nigeria.
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
